document.addEventListener("DOMContentLoaded", function () {
  const items = document.querySelectorAll(".bundle-item");
  const progress = document.querySelector(".progress-fill");
  const quantityInput = document.querySelector('input[name="quantity"]');

  let lockedMin = 1; // default

function updateProgress(index) {
  const steps = document.querySelectorAll(".step");

  // match exact step position
  const percent = (index / (steps.length - 1)) * 100;

  progress.style.height = percent + "%";

  steps.forEach((step, i) => {
    step.classList.remove("active", "completed");

    if (i < index) {
      step.classList.add("completed");
    } else if (i === index) {
      step.classList.add("active");
    }
  });
}

 function setActive(item, index, fromInput = false) {
  items.forEach(i => i.classList.remove("active"));
  item.classList.add("active");

  const radio = item.querySelector('input[type="radio"]');
  if (radio) radio.checked = true;

  // ✅ ONLY update quantity if NOT from input
  if (!fromInput) {
    const qty = parseInt(item.getAttribute("data-qty"));
    quantityInput.value = qty;
  }

  updateProgress(index);
}

  //  Click selection
  items.forEach((item, index) => {
    item.addEventListener("click", () => {
      setActive(item, index);
    });
  });

  //  Prevent going below locked value
  quantityInput.addEventListener("input", function () {
    let val = parseInt(this.value) || 1;

    if (val < lockedMin) {
      this.value = lockedMin;
    }
  });

  // Prevent minus button going below
quantityInput.addEventListener("change", function () {
  let val = parseInt(this.value) || 1;

  let selectedIndex = 0;

  items.forEach((item, index) => {
    const itemQty = parseInt(item.getAttribute("data-qty"));

    if (itemQty <= val) {
      selectedIndex = index;
    }
  });

  const selectedItem = items[selectedIndex];

  if (!selectedItem.classList.contains("active")) {
    setActive(selectedItem, selectedIndex, true); // 👈 IMPORTANT
  }
});

  //  Default = 1
  const defaultItem = document.querySelector('.bundle-item[data-qty="1"]');
  if (defaultItem) {
    const index = [...items].indexOf(defaultItem);
    setActive(defaultItem, index);
  }
});